import { createConfig } from 'navigation-components/platform/models';
import { chatspotSidebarComponentDef } from './chatspot-sidebar';
import { CHATSPOT_SIDEBAR_COMPONENT, DUMMY_COMPONENT, GLOBAL_SEARCH_COMPONENT, IN_APP_HELP_COMPONENT, GROWTH_PROMPTS_COMPONENT, GROWTH_UPGRADE_BUTTON_COMPONENT, CALLING_COMPONENT, NOTIFICATIONS_BANNER_COMPONENT, NOTIFICATIONS_FLOATING_COMPONENT, NOTIFICATIONS_TEASE_COMPONENT, NOTIFICATIONS_SIDEBAR_COMPONENT, NAV_OBJECT_CREATE_COMPONENT, MARKETPLACE_NAV_MENU_COMPONENT, QUARTER_IN_REVIEW_MODAL_COMPONENT, ACADEMY_TOOLBAR_COMPONENT, ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT, NAV_ONBOARDING_TOURS_COMPONENT, TRIAL_BANNER_COMPONENT, USER_INVITE_MODAL_COMPONENT, GROWTH_IN_APP_SIDEPANEL_COMPONENT, MINI_TRIAL_GUIDE_COMPONENT } from './constants';
import { dummyComponentDef } from './dummy';
import { globalSearchComponentDef } from './global-search';
import { inAppHelpNavComponentDef } from './in-app-help';
import { growthPromptsComponentDef } from './growth-prompts';
import { growthUpgradeButtonComponentDef } from './growth-upgrade-button';
import { callingComponentDef } from './calling';
import { bannerNotificationsComponentDef, floatingNotificationsComponentDef, teaseNotificationsComponentDef, sidebarNotificationsComponentDef } from './notifications';
import { navObjectCreateDef } from './nav-object-create-ui';
import { marketplaceNavMenuComponentDef } from './marketplace-nav-menu';
import { quarterInReviewModalComponentDef } from './quarter-in-review-modal';
import { academyExerciseInstructionsNavComponentDef, academyToolbarNavComponentDef } from './academy';
import { trialBannerComponentDef } from './trial-banner';
import { navOnboardingToursComponentDef } from './nav-onboarding-tours';
import { userInviteModalDef } from './user-invite-modal/user-invite-modal.config';
import { growthInAppSidepanelComponentDef } from './growth-in-app-sidepanel/growth-in-app-sidepanel.config';
import { miniTrialGuideComponentDef } from './mini-trial-guide/mini-trial-guide.config';
export const navigationComponentsConfig = createConfig({
  [GLOBAL_SEARCH_COMPONENT]: globalSearchComponentDef,
  [DUMMY_COMPONENT]: dummyComponentDef,
  [CHATSPOT_SIDEBAR_COMPONENT]: chatspotSidebarComponentDef,
  [IN_APP_HELP_COMPONENT]: inAppHelpNavComponentDef,
  [GROWTH_PROMPTS_COMPONENT]: growthPromptsComponentDef,
  [GROWTH_UPGRADE_BUTTON_COMPONENT]: growthUpgradeButtonComponentDef,
  [CALLING_COMPONENT]: callingComponentDef,
  [NOTIFICATIONS_BANNER_COMPONENT]: bannerNotificationsComponentDef,
  [NOTIFICATIONS_FLOATING_COMPONENT]: floatingNotificationsComponentDef,
  [NOTIFICATIONS_TEASE_COMPONENT]: teaseNotificationsComponentDef,
  [NAV_OBJECT_CREATE_COMPONENT]: navObjectCreateDef,
  [NOTIFICATIONS_SIDEBAR_COMPONENT]: sidebarNotificationsComponentDef,
  [MARKETPLACE_NAV_MENU_COMPONENT]: marketplaceNavMenuComponentDef,
  [QUARTER_IN_REVIEW_MODAL_COMPONENT]: quarterInReviewModalComponentDef,
  [ACADEMY_TOOLBAR_COMPONENT]: academyToolbarNavComponentDef,
  [ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT]: academyExerciseInstructionsNavComponentDef,
  [TRIAL_BANNER_COMPONENT]: trialBannerComponentDef,
  [NAV_ONBOARDING_TOURS_COMPONENT]: navOnboardingToursComponentDef,
  [USER_INVITE_MODAL_COMPONENT]: userInviteModalDef,
  [GROWTH_IN_APP_SIDEPANEL_COMPONENT]: growthInAppSidepanelComponentDef,
  [MINI_TRIAL_GUIDE_COMPONENT]: miniTrialGuideComponentDef
});